import { defineStore } from 'pinia';
import { apiClient } from '@/Clients/ApiClient';
import ProjectCatalogCategoriesService from '@/Services/ProjectCatalogCategoriesService';

export const usePlatformCatalogCategoriesStore = defineStore({
    id: 'platformCatalogCategories',
    state: () => ({
        categories: [],
        isLoaded: false,
    }),
    actions: {
        async fetchCategories() {
            if (this.isLoaded) {
                return;
            }
            const service = new ProjectCatalogCategoriesService(apiClient);
            const { data } = await service.getProjectCatalogCategories();
            this.categories = data;
            this.isLoaded = true;
        },
    },
    getters: {
        platformCatalogCategories: state => {
            return state.categories;
        },
    },
});